export const COMMENTS_LOAD_ERROR = 'Ошибка при загрузке комментариев:';
export const COMMENT_SEND_ERROR = 'Ошибка при отправке комментария:';
export const COMMENT_TEXT_MIN_LENGTH_ERROR =
  'Комментарий должен содержать не менее 5 символов';
export const COMMENT_REPLY_SEND_ERROR = 'Ошибка при отправке ответа на комментарий:';
export const ARTICLE_LAWYERS_LOAD_ERROR = 'Ошибка при загрузке рекомендованных юристов:';
export const AUTHOR_ARTICLES_LOAD_ERROR = 'Ошибка при загрузке статей автора:';
export const SIMILAR_ARTICLES_LOAD_ERROR = 'Ошибка при загрузке похожих статей:';
export const CATEGORY_MORPHOLOGY_FETCH_ERROR =
  'Ошибка при получении морфологии категории:';
export const ARTICLE_FAVORITE_TOGGLE_ERROR = 'Ошибка при изменении избранного статьи:';
